import './styles/service.css'
import serviceImg1 from '../assets/icons/account.svg'
import serviceImg2 from '../assets/icons/goal.svg'
import serviceImg3 from '../assets/icons/jobsearch.svg'
import mainImg from '../assets/images/main-img2.png'

const serviceCards = [
    {
        img:serviceImg1,
        title:'LinkedIn SEO',
        text:`Simply download our free browser extension, navigate 
        to your LinkedIn profile and start a scan. Our software will 
        provide feedback to help you optimize your LinkedIn profile, 
        and start getting noticed in search results!`
    },
    {
        img:serviceImg2,
        title:'Targeted Resume',
        text:`No more hoping that your application will be seen by a human. 
        Our unique AI driven resume scanner will compare your resume to a specific job listing, 
        and make recommendations on how you can better optimize your resume in order to beat the ATS.`
    },
    {
        img:serviceImg3,
        title:'Job Search',
        text:`If you’re satisfied with your resume, our AI driven software can 
        identify job listings that best match your resume. We aggregate job listings from
         multiple sources, and list jobs that give you the best chances of hearing from a recruiter.`
    },
]

export default function Service() {
  return (
    <div id='extension' className='service'>
        <div className="container">
            <div className='service__body'>
                <div className='service__head'>
                    <div className='service__label'>One great price</div>
                    <div className='service__title'>Premier Service</div>
                </div>
                <div className='service__colums'>
                    <div className='service__cards'>
                    {serviceCards.map((card) => {
                        return (
                            <div key={card.title} className='service__card'>
                                <div className='service__card-img'>
                                    <img src={card.img} alt={card.title}/>
                                </div>
                                <div className='service__card-info'>
                                    <div className='serivce__card-title'>
                                        {card.title}
                                    </div>
                                    <div className='service__card-text'>
                                        {card.text}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    </div>
                    <div className='service__img'>
                        <img src={mainImg} alt={'main-img2'}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
